export default "52dc42463038d9ec.svg"